import React, { useState } from 'react';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { GreySections } from '../../features/Datamanager/Inspector/GreySections';
import { TColorRole } from '../../../types/types';

interface IHideShowSectionProps {
    label: string;
    children?: React.ReactNode;
    hasArrow?: boolean;
    color?:  TColorRole;
    arrowSize?: number;
    defaultClose?: boolean;
    showTitle?: boolean;
    removeSpacing? : boolean;
    setGap?: number;

}

export const HideShowSection: React.FC<IHideShowSectionProps> = ({setGap = 0.5, removeSpacing = false, showTitle = true, defaultClose = true, arrowSize = 1.4, color = "grey-superLight", label, children, hasArrow = true }) => {
    const [closeSection, setCloseSection] = useState<boolean>(defaultClose);

    const onSectionClose = () => {
        setCloseSection((prev: boolean) => !prev);
    };

    return (
        <GreySections removeSpacing = {removeSpacing} showTitle = {showTitle} arrowSize = {arrowSize} color={color} title={label} func={() => onSectionClose()} closeSection={closeSection} hasArrow={hasArrow}>
            <FlexCenter gap={setGap} position="start">
                {closeSection && children}
            </FlexCenter>
        </GreySections>
    );
};
